import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	previousIssueTooltip: {
		id: string;
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: string;
		description: string;
	};
	previousIssueWithoutKeyTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disabledButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disabledButtonLabelIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previousIssueTooltipIssueTermRefresh: {
		id: string;
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: string;
		description: string;
	};
	previousIssueWithoutKeyTooltipIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	previousIssueTooltip: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: "Previous issue ''{issueKey}'' (Type 'k')",
		description:
			'Tooltip shown on the button to select the previous issue followed by the keyboard shortcut to perform the action.',
	},
	previousIssueWithoutKeyTooltip: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip',
		defaultMessage: "Previous issue (Type 'k')",
		description:
			'Tooltip shown on the button to select the previous issue followed by the keyboard shortcut to perform the action.',
	},
	disabledButtonLabel: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label',
		defaultMessage: 'No previous issue, select next issue',
		description:
			'Aria label when on first issue and the "Previous issue" button is disabled. The message tells users they are on the first issue and they can look at next issues instead.',
	},
	disabledButtonLabelIssueTermRefresh: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label-issue-term-refresh',
		defaultMessage: 'No previous work item, select next work item',
		description:
			'Aria label when on first issue and the "Previous issue" button is disabled. The message tells users they are on the first issue and they can look at next issues instead.',
	},
	previousIssueTooltipIssueTermRefresh: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: "Previous work item ''{issueKey}'' (Type 'k')",
		description:
			'Tooltip shown on the button to select the previous issue followed by the keyboard shortcut to perform the action.',
	},
	previousIssueWithoutKeyTooltipIssueTermRefresh: {
		id: 'issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh',
		defaultMessage: "Previous work item (Type 'k')",
		description:
			'Tooltip shown on the button to select the previous issue followed by the keyboard shortcut to perform the action.',
	},
});
export default messages;
